<template>
    <tr :key="item.answer_id">
        <td>{{ item.question }}</td>
        <td>{{ item.answer }}</td>
        <td><v-icon small v-if="item.file !== null && item.file !== ''" @click="viewFile(item.file)" color="success">mdi-file-find</v-icon><v-icon v-else @click="selectFile(item.file)" small>mdi-dots-horizontal</v-icon></td>
        <td v-if="stage != 'C30:FINAL_INVOICE'"><v-icon small v-if="item.sto_file !== null" @click="">mdi-file-find</v-icon><v-icon @click="" small v-else>mdi-upload</v-icon></td>
        <td>{{ item.finaly_point }}</td>
        <td>{{ item.point }}</td>
        <td><v-icon v-if="item.comment !== null && item.comment !== ''" color="success" small @click="editComment(item.question_id)">mdi-chat-processing</v-icon><v-icon v-else small @click="editComment(item.question_id)">mdi-chat-processing</v-icon></td>
        <td  v-if="stage!= 'C30:FINAL_INVOICE'">{{ item.sto_comment }}</td>
        <td>{{ item.finaly_point }}</td>
        <td>{{ item.penalty_point }}</td>
        <!--<td><v-icon small @click="">edit</v-icon></td>-->
    </tr>
</template>

<script>
  export default {
    name: 'ShopperTableRow',
    props: ['item', 'stage'],
    methods: {
      selectFile: function (question_id) {
        this.$emit('selectfile', {question_id: question_id})
      },
      editComment: function (question_id) {
        alert('Тут откроется диалог для добавления/редактирования комментария для вопроса: ' + question_id)
      },
      viewFile: function (fileCode) {
        alert(`Сейчас мы покажем файл: ${fileCode}`)
        this.$emit('viewfile', {file: fileCode})
      }
    }
  }
</script>

<style scoped>

</style>